package com.kinoshazam.di

import org.koin.core.module.Module
import org.koin.dsl.module

expect fun coreModule(): Module

internal fun common(): Module = module {

}